import { render, staticRenderFns } from "./RenamePortfolioModal.vue?vue&type=template&id=098672d0&scoped=true&"
import script from "./RenamePortfolioModal.vue?vue&type=script&setup=true&lang=ts&"
export * from "./RenamePortfolioModal.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./RenamePortfolioModal.vue?vue&type=style&index=0&id=098672d0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098672d0",
  null
  
)

export default component.exports